require('./_set-species')('Array');



/*****************
 ** WEBPACK FOOTER
 ** /Users/luca/dev/juta/ironex.it/~/core-js/modules/es6.array.species.js
 ** module id = 179
 ** module chunks = 0
 **/